import styled from 'styled-components';
import { Utils } from 'billon-ui';

const { Button: ButtonModule } = Utils;
const { IconButton } = ButtonModule;

export const RefreshButtonWrapper = styled(IconButton)`
  margin-left: 1rem;
`;
